import selectTotalFields from './select-total-fields';
import {createSelector} from '@reduxjs/toolkit';

export default (coe: number) =>
  createSelector([selectTotalFields], totals => {
    return coe * Number(totals?.decorator_price);
  });
